{
  "version": 1,
  "asset_id": "19935b13-4c75-465e-8675-2e742da0a409",
  "project_id": "6ffb2ed6-aa93-4c00-8eaf-179cce7a3ceb",
  "url": "/__l5e/assets-v1/19935b13-4c75-465e-8675-2e742da0a409/taper-fade-v1-2.webp",
  "r2_key": "a/v1/6ffb2ed6-aa93-4c00-8eaf-179cce7a3ceb/19935b13-4c75-465e-8675-2e742da0a409/taper-fade-v1-2.webp",
  "original_filename": "taper-fade-v1-2.webp",
  "size": 72766,
  "content_type": "image/webp",
  "created_at": "2026-09-09T09:54:39Z"
}
